/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartAxisX = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M4 15v5h16v-5h2v7H2v-7zM16.293 2l1.414 1.415-4.293 4.292 4.293 4.294-1.414 1.414L12 9.121l-4.293 4.294-1.414-1.414 4.293-4.294-4.293-4.292L7.707 2 12 6.293z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgChartAxisX as ChartAxisX };
